import { render, staticRenderFns } from "./Anexos.vue?vue&type=template&id=3724e392&scoped=true"
import script from "./Anexos.vue?vue&type=script&lang=js"
export * from "./Anexos.vue?vue&type=script&lang=js"
import style0 from "./Anexos.vue?vue&type=style&index=0&id=3724e392&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3724e392",
  null
  
)

export default component.exports